import React from "react";

function WithDrawalCard({ style = 1, children, cssStyle = {} }) {
  return (
    <div
      style={{ ...cssStyle }}
      className={`withdrawal-card-new style${style}`}
    >
      {children}
    </div>
  );
}

export default WithDrawalCard;
